// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__ugdqi","content":"Details_content__1Vdhm"};